import { PractitionerSessionStatus } from 'src/enums/session.status';

import { IOptionType } from 'src/pods/system/models/OptionModel';

import { translate } from 'src/translations/translations';

export const statusListOptions: IOptionType[] = [
    { label: translate('sessions.status.scheduled'), value: PractitionerSessionStatus.SESSION_STATUS_REQUESTED },
    { label: translate('sessions.status.accepted'), value: PractitionerSessionStatus.SESSION_STATUS_ACCEPTED },
    { label: translate('sessions.status.declined'), value: PractitionerSessionStatus.SESSION_STATUS_DECLINED },
];
